import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import { NewsletterPopupMock } from './custom-component-mocks';
import { AirwickNewsletterPopup } from './src/@husky-x/gatsby-theme-husky/components/newsletter-popup';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'newsletter-popup',
        component: () => <AirwickNewsletterPopup {...NewsletterPopupMock} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
